<div class="pcf">
  <div class="pcf-pair">
    <mat-form-field appearance="outline">
      <mat-label>Correo electrónico</mat-label>
      <mat-icon matPrefix class="pcf-icon">mail</mat-icon>
      <input matInput name="email" email autocomplete="off" [ngModel]="email" (ngModelChange)="onEmailChange($event)">
      <mat-error>Ingresa un formato de correo válido</mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Celular</mat-label>
      <mat-icon matPrefix class="pcf-icon">phone</mat-icon>
      <input matInput name="phone" placeholder="10 dígitos" inputmode="numeric" autocomplete="off" minlength="10" maxlength="10"
             [ngModel]="phone" (ngModelChange)="onPhoneChange($event)">
      <mat-error>Ingresa un número válido (10 dígitos)</mat-error>
    </mat-form-field>
  </div>

  <p class="pcf-note" [class.pcf-note-warn]="warnWhenMissing && missingContact">
    <mat-icon>lock_outline</mat-icon>
    <span>{{ note }}</span>
  </p>
</div>
